<template>
  <div>
    <div class="hero-image" :style="{'background-image': `url('https://www.thethinkingtraveller.com/media/homepage/hero/homepage_hero_fallback.jpg')` }" />
    <Vimeo :id="820066441" class="hero-image" :image="'https://www.thethinkingtraveller.com/media/homepage/hero/homepage_hero_fallback.jpg'" />
    <div class="hero-image overlay" />

    <div class="homepage__hero">
      <div class="homepage__hero--wrapper text-center">
        <div>
          <p v-if="isDesktop" class="homepage__hero--subtitle">
            Hot tubs and spa treatments. Yoga classes at sunrise.<br>
            Views that stop time. We love villas with no agenda.
          </p>
          <h1 class="homepage__hero--title uppercase">
            <span class="capitalcase">The</span> Sweetness <span class="lowercase">of</span> doing nothing
          </h1>
          <p v-if="!isDesktop" class="homepage__hero--subtitle">
            Hot tubs and spa treatments. Yoga classes at sunrise.<br>
            Views that stop time. We love villas with no agenda.
          </p>
          <app-link id="16" type="page" class="btn-secondary-light-sm">
            Find your dream villa
          </app-link>
        </div>
      </div>
      <!-- <app-link :id="this.currentVilla.link" type="villa" class="homepage__hero--signpost">
        <font-awesome-icon :icon="['fal', 'map-marker-alt']" aria-label="map marker" />
        <span>{{ this.currentVilla.signpost }}</span>
      </app-link> -->
    </div>
  </div>
</template>

<script>
import responsive from '../../mixins/responsive';
import Vimeo from '../../components/Vimeo.vue';

export default {
  components: {
    Vimeo,
  },
  mixins: [responsive],
  data() {
    return {
    };
  },
  created() {
    this.loadVillaImage();
  },
  methods: {
    loadVillaImage() {
      if (this.randomImageIndex == -1) {
        this.randomImageIndex = Math.floor(Math.random() * this.images.length);
        this.currentVilla = this.images[this.randomImageIndex];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/settings/config.scss';
$hero-height: 465px;
// Please do not add z-index layering in this file as the full screen date picker is wrapped in these sections on the home page

.hero-image {
  background-size: cover;
  background-position: center;
}

.hero-overlay {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 49%, rgba(0, 0, 0, 0));
}

.hero-image {
  position: absolute;
  width: 100%;
  height: 100vh;
  // min-height: 750px;
  top: 0;
  left: 0;
  @media (max-width: 480px) {
    min-height: 568px;
  }
  &.overlay {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.homepage{
  position: absolute;
  top: 0;
  left: 0;
  &__hero {
  position: relative;
  &--wrapper {
    padding: 2em 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    max-width: 970px;
    margin: 0 auto;
    padding: 4em 0;
    height: calc(100vh - 111.5px);

    @media (max-width: 900px) {
      // compensating for height of the topbar
      height: calc(100vh - 60px); // Ensure hero search is above bottom nav on mobile
      // margin-bottom: 10vh; // push rest of page content down
    }
    @media (max-width: 574px) {
      // compensating for height of the topbar
      min-height: calc(568px - 49.5px);
    }
  }

  &--signpost {
    position: absolute;
    bottom: 60px;
    left: 0;
    background-color: $black;
    color: $stoneWhite;
    font-size: 21px;
    padding: 15px 21px 15px 75px;
    & span {
      margin-left: 9px;
    }
    @media (max-width: 820px) {
      background: transparent;
      left: 0;
      right: 0;
      padding: 0;
      bottom: -10px;
      font-size: 16px;
    }
  }

  &--title {
    position: relative;
    margin: 0 auto;
    padding: 0 1em;
    color: $stoneWhite;
    font-size: calc(7.5vh + 1rem);
    text-align: center;
    line-height: 1.2;
    margin-bottom: 32px;
    @media screen and (max-width: 900px) {
      font-size: calc(4.5vh + 1.5rem);
    }
    @media screen and (max-width: 414px) {
      font-size: calc(3.7vh + 1.3rem);
    }
  }
  &--subtitle {
    color: $stoneWhite;
    margin-bottom: 2em;
    font-size: calc(1vh + 0.6rem);
    @media screen and (max-width: 900px) {
      font-size: calc(1vh + 0.5rem);
      }
    @media screen and (max-width: 414px) {
      font-size: calc(0.7vh + 0.5rem);
      }
    }
  }
}

.show-mobile-tablet {
  margin-bottom: 20px;
  @media (min-width: 1025px) {
    display: none;
  }
}

.show-desktop {
  margin-top: 20px;
  @media (max-width: 1025px) {
    display: none;
  }
}

</style>
